import React, { useRef, useState } from "react";
import "../QuoteForm.css";


function BookInfoSection({ bookInfo, handleBookInfoChange }) {
    const [fileError, setFileError] = useState(null);
    const fileInputRef = useRef(null);
    const pageOptions = [200, 250, 300, 350, 400, 450, 500];

    const MAX_FILE_SIZE_MB = 25; // file size threshold
    const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
    const MAX_FILES = 5;

    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files);

        const oversized = newFiles.filter((file) => file.size > MAX_FILE_SIZE);
        if (oversized.length > 0) {
            setFileError(`파일 크기는 ${MAX_FILE_SIZE_MB}MB를 초과할 수 없습니다.`);
            return;
        }

        if ((bookInfo.manuscriptFiles?.length || 0) + newFiles.length > MAX_FILES) {
            setFileError(`최대 ${MAX_FILES}개 파일만 업로드할 수 있습니다.`);
            return;
        }

        const existingFiles = bookInfo.manuscriptFiles || [];
        const duplciates = newFiles.filter((newFile) =>
            existingFiles.some(
                (existingFile) =>
                    existingFile.name === newFile.name &&
                    existingFile.size === newFile.size
            )
        );

        if (duplciates.length > 0) {
            setFileError("중복된 파일은 업로드할 수 없습니다.");
            return;
        }

        setFileError(null);

        const updatedFiles = [...(bookInfo.manuscriptFiles || []), ...newFiles];

        handleBookInfoChange({
            target: {
                name: "manuscriptFiles",
                value: updatedFiles
            }
        });

        e.target.value = null;
    };

    const handleRemoveFile = (index) => {
        const updatedFiles = bookInfo.manuscriptFiles.filter((_, i) => i !== index);

        handleBookInfoChange({
            target: {
                name: "manuscriptFiles",
                value: updatedFiles
            }
        });
    };

    return (
        <div className="book-info-container">
            <div className="book-info-section">
                <h2>도서 정보</h2>
                <div className="book-info-grid">
                    <div className="info-item">
                        <label>
                            도서명: <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="text"
                            name="title"
                            value={bookInfo.title}
                            onChange={handleBookInfoChange}
                            placeholder="도서명을 작성해 주세요"
                        />
                    </div>
                    <div className="info-item">
                        <label>
                            저자명: <span style={{ color: "red" }}>*</span> 
                        </label>
                        <input
                            type="text"
                            name="author"
                            value={bookInfo.author}
                            onChange={handleBookInfoChange}
                            placeholder="저자명을 작성해 주세요"
                        />
                    </div>
                    <div className="info-item">
                        <label>원고 작성률(%)</label>
                        <input
                            type="number"
                            name="completionRate"
                            value={bookInfo.completionRate}
                            onChange={handleBookInfoChange}
                            placeholder="예: 80"
                        />
                    </div>
                    <div className="info-item">
                        <label>페이지 수</label>
                        <select
                            name="numberOfPages"
                            value={bookInfo.numberOfPages}
                            onChange={handleBookInfoChange}
                        >
                            {pageOptions.map((pages) => (
                                <option key={pages} value={pages}>
                                    {pages} 페이지
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="info-item">
                        <label>원고 업로드</label>
                        <div className="manuscript-upload-section new-style">
                            <div className="file-names-display">
                                {bookInfo.manuscriptFiles && bookInfo.manuscriptFiles.length > 0 ?
                                    bookInfo.manuscriptFiles.map((file, index) => (
                                        <div key={index} className="file-name">
                                            
                                            <div
                                                className="remove-file-button"
                                                onClick={() => handleRemoveFile(index)}
                                            >
                                                <img src="./images/close_icon_30.png"/>
                                            </div>
                                            <span>{file.name}</span>
                                        </div>
                                    ))
                                    :
                                    "파일을 선택해 주세요(최대 5개)"
                                }
                            </div>
                            <input
                                type="file"
                                ref={fileInputRef}
                                name="manuscriptFiles"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                                accept=".pdf,.doc,.docx,.hwp,.txt"
                                multiple
                            />
                            <button
                                type="button"
                                className="upload-button"
                                onClick={handleUploadClick}
                            >
                                파일 선택
                            </button>
                        </div>
                        {fileError != null &&
                            <>
                                <div></div>
                                <div className="file-error-message">
                                    {fileError}
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BookInfoSection;